module.exports = __webpack_public_path__ + "assets/img/Logo-GBM.8afc5d1d.png";